/* eslint-disable  */
import React, { useEffect, useState, useMemo } from 'react'
import Dayjs from 'dayjs'
import {
	Typography,
	Button,
	Dialog,
	DialogContent,
	Grid,
	IconButton,
	Menu,
	MenuItem,
	TextField,
	Chip,
} from '@material-ui/core'
import _ from 'lodash'
import { MoreVert } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { DataGrid } from '@mui/x-data-grid'
import Dimmer from '+/Dimmer'
import { useDeleteWhip, useUpdateWhip, useWhips } from '~/whips'
import WhipsCreateForm from './whipsCreateForm'
import WhipsUpdateForm from './whipsUpdateForm'
import Swal from '#/swal';

export const sortPricing = pricing => {
    const sortedPricing = _.sortBy(pricing)
    if (sortedPricing.length > 0) {
        return `${sortedPricing[0]} - ${sortedPricing[sortedPricing.length - 1]}`
    }
    return ''
}

const Whips = props => {
	const {
		data: whips,
		isLoading: loadingWhips,
		isError: errorLoadingWhips,
	} = useWhips()

	const { mutate: deleteWhip } = useDeleteWhip()

	const classes = useStyles()
	const [query, setQuery] = useState()
	const [rowSelected, setRowSelected] = useState()
	const [actions, setActions] = useState(null)
	const [createModalOpen, setCreateModalOpen] = useState(false)
	const [updateModalOpen, setUpdateModalOpen] = useState(false)

	const whipsLoaded = useMemo(() => {
		if (!whips) return []
		if (!query) return whips.rows
		return whips.rows.filter(whip => {
			const regex = new RegExp(query, 'i')
			return (
				regex.test(whip.unit_number) ||
				regex.test(whip.prop_name)
				// regex.test(whip.unit_type_name)
			)
		})
	}, [whips, query])

	const handleColorStatus = status => {
		if (status === 'resident_opt_out' || status === 'rejected' ) {
			return 'red'
		} else if (status === 'verified') {
			return 'green'
		} else {
			return 'orange'
		}
	}

	const handleDelete =  async id => {

		const {value} = await Swal.fire.warning({ text: 'Are you sure you want to delete??'})
		if (value) {
			deleteWhip(id)
		}
		
	}
	

	const columns = useMemo(
		() => [
			{
				field: 'prop_name',
				renderHeader: () => <strong>Property</strong>,
				flex: 1,
			},
			{
				field: 'whip_id',
				renderHeader: () => <strong>Whip ID</strong>,
				valueGetter: ({ row }) => row.id,
				flex: 1,
			},
			{
				field: 'unit_number',
				renderHeader: () => <strong>Unit Number</strong>,
				flex: 1,
			},
			{
				field: 'applicants',
				renderHeader: () => <strong>Applicants</strong>,
				flex: 1,
			},
			{
				field: 'status',
				renderHeader: () => <strong>Status</strong>,
				renderCell: ({ row }) => {
					return (
						<Chip
							variant='outlined'
							label={row.status}
                            style={{
                                fontSize: '10px',
                                padding: '1px',
                                color: handleColorStatus(row.status),
                                borderColor: handleColorStatus(row.status),
                            }}
						/>
					)
				},
				flex: 1,
			},
			{
				field: 'comments',
				renderHeader: () => <strong>Comments</strong>,
				flex: 1,
			},
			{
				field: 'created_at',
				renderHeader: () => <strong>Created At</strong>,
				renderCell: ({ row }) => {
					return Dayjs(row.created_at).format('MM/DD/YYYY')
				},
				type: 'date',
				flex: 1,
			},
			{

				field: 'event',
				renderHeader: () => <strong>Event</strong>,
				flex: 1,
			},
			{
				field: 'event_date',
				renderHeader: () => <strong>Event Date</strong>,
				renderCell: ({ row }) => {
					if (row.event_date){
						return Dayjs(row.event_date).format('MM/DD/YYYY')
					} else {
						return ''
					}
					
				},
				type: 'date',
				flex: 1,
			},
			{

				field: 'resident_name',
				renderHeader: () => <strong>Event Resident</strong>,
				flex: 1,
			},
			{
				field: 'id',
				align: 'right',
				headerAlign: 'right',
				renderHeader: () => <strong>Actions</strong>,
				renderCell: ({ row }) => (
					<div>
						<IconButton onClick={e => openPopover(e, row)}>
							<MoreVert />
						</IconButton>
					</div>
				),
				flex: 1,

			}
			// {
			// 	field: 'pricing',
			// 	renderHeader: () => <strong>Pricing</strong>,
			// 	renderCell: ({ row }) => sortPricing( row.pricing ),
			// 	flex: 1,
			// },
			// {
			// 	field: 'current_rent',
			// 	renderHeader: () => <strong>Current Rent</strong>,
			// 	flex: 1,
			// },
			// {
			// 	field: 'going_rent',
			// 	renderHeader: () => <strong>Goin Rent</strong>,
			// 	flex: 1,
			// },
			// {
			// 	field: 'renewal_notes',
			// 	renderHeader: () => <strong>Renewal Notes</strong>,
			// 	flex: 1,
			// },
			// {
			// 	field: 'lease_end_date',
			// 	renderHeader: () => <strong>Lease End</strong>,
			// 	renderCell: ({ row }) => {
			// 		return Dayjs(row.lease_end_date).format('MM/DD/YYYY')
			// 	},
			// 	type: 'date',
			// 	flex: 1,
			// }
			// eslint-disable-next-line react-hooks/exhaustive-deps
		],
		[]
	)

	const openPopover = (event, row) => {
		setRowSelected(row)
		setActions(event.currentTarget)
	}

	const closePopover = () => {
		setActions(null)
	}

	const moreActions = Boolean(actions)

	if (errorLoadingWhips) {
		return <Dimmer message='SOMETHING WENT WRONG, PLEASE RELOAD PAGE' />
	}

	if (loadingWhips || !whips) {
		return <Dimmer message='Loading....This may take a while.' />
	}

	return (
		<div>
			<Grid
				container
				justifyContent='space-between'
				style={{ marginBottom: '20px', marginTop: '20px' }}
			>
				<Grid item>
					<Typography variant='h4' children='Whips' />
				</Grid>
				<Grid item xs={6}>
					<TextField
						name='search_whips'
						label='Search Whips'
						variant='outlined'
						size='small'
						fullWidth
						style={{
							marginTop: '50px',
						}}
						onChange={e => setQuery(e.target.value)}
					/>
				</Grid>
				<Grid item>
					<Button
						children='New Whips'
						variant='contained'
						color='primary'
						onClick={() => {
							setCreateModalOpen(true)
						}}
					/>
				</Grid>
			</Grid>

			<div className={classes.tableWrapper}>
				<DataGrid
					className={classes.dataGrid}
					loading={loadingWhips}
					columns={columns}
					rows={whipsLoaded || []}
					autoHeight
					// hideFooterSelectedRowCount
					// hideFooterPagination
				/>
			</div>

			<div>
				<Menu
					id='actions'
					open={moreActions}
					anchorEl={actions}
					onClose={closePopover}
					onClickCapture={closePopover}
				>
					<MenuItem
						onClick={() => {
							setUpdateModalOpen(true)
						}}
					>
						Edit
					</MenuItem>
					<MenuItem
						onClick={() => handleDelete(rowSelected.id) }
					>
						Delete
					</MenuItem>
				</Menu>
			</div>

			<Dialog
				open={createModalOpen}
				onClose={() => {
					setCreateModalOpen(false)
					setRowSelected()
				}}
			>
				<DialogContent>
					<WhipsCreateForm
						setModalOpen={setCreateModalOpen}
					/>
				</DialogContent>
			</Dialog>

            <Dialog
				open={updateModalOpen}
				onClose={() => {
					setUpdateModalOpen(false)
					setRowSelected()
				}}
			>
				<DialogContent>
					<WhipsUpdateForm
						setModalOpen={setUpdateModalOpen}
						whipValues={rowSelected}
					/>
				</DialogContent>
			</Dialog>
		</div>
	)
}

export default Whips

const useStyles = makeStyles({
	dataGrid: {
		'&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus':
			{
				outline: 'none',
			},
	},
	tableWrapper: {
		width: '100%',
	},
	redButton: {
		color: '#fff',
		backgroundColor: '#DB2828',
	},
})
